import { useState } from 'react';
import { getTask } from '../tasks';
import { MessageImportPanel } from '../tasks/components/MessageImportPanel';
import { MessagePoolStats } from '../tasks/components/MessagePoolStats';
import { button, Notice, Panel, useCan, useResource } from './ui';

/** Materials belong to the published formal task, never the draft revision. */
export function AgentMessagePool({ formalTaskId }: { formalTaskId?: number }) {
  const canImport = useCan('message_import_admin');
  if (!formalTaskId || !canImport) return null;
  return <PublishedMessagePool key={formalTaskId} formalTaskId={formalTaskId} />;
}

function PublishedMessagePool({ formalTaskId }: { formalTaskId: number }) {
  const formal = useResource(() => getTask(formalTaskId), [formalTaskId]);
  const canSuppress = useCan('message_compliance_admin');
  const [refreshKey, setRefreshKey] = useState(0);
  if (formal.loading) return <p className="text-sm text-gray-500">正在加载正式任务素材…</p>;
  if (formal.error) return <Panel title="正式任务素材"><Notice error={formal.error} /><button className={button} onClick={formal.reload}>重试</button></Panel>;
  if (formal.data?.task_type !== 'message_send') return null;

  return (
    <Panel title="正式 iMessage 任务素材与库存">
      <p className="text-sm text-gray-500">
        以下素材用于正式任务 #{formalTaskId}。导入后可供会员领取；任务内容与配置仍通过商户版本审核管理。
      </p>
      <MessageImportPanel
        taskId={formalTaskId}
        onCommitted={() => setRefreshKey((value) => value + 1)}
      />
      <MessagePoolStats
        taskId={formalTaskId}
        refreshKey={refreshKey}
        canSuppress={canSuppress}
        showKillSwitch={false}
      />
    </Panel>
  );
}
